import { render, staticRenderFns } from "./ChecklistFieldModule.vue?vue&type=template&id=3dd7cbcb&scoped=true"
import script from "./ChecklistFieldModule.vue?vue&type=script&lang=ts"
export * from "./ChecklistFieldModule.vue?vue&type=script&lang=ts"
import style0 from "./ChecklistFieldModule.vue?vue&type=style&index=0&id=3dd7cbcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd7cbcb",
  null
  
)

export default component.exports